<template>
  <div v-if="wrapItems.length > 0">
    <p>Thông tin cửa hàng</p>
    <b-table
      thead-tr-class="z-0"
      style="min-height: auto"
      :items="wrapItems"
      :fields="fields"
      :bordered="true"
    >
      <template #cell(areaAddress)="{ item }">
        {{ item.areaAddress }} - {{ item?.areaWard }} - {{ item.areaDistrict }} -
        {{ item.areaCity }}
      </template>
      <template #cell(typeStore)="{ item }">
        {{ item.isNew && item.isNew === true ? 'Cửa hàng mới' : '' }}
      </template>
      <template #cell(areaUrl)="{ item }">
        <template v-if="item.areaUrl">
          <b-button
            @click="showImage(item.areaUrl)"
            v-b-tooltip.hover
            variant="outline-secondary"
            size="sm"
            title="Xem"
          >
            <i class="bx bx-show p-0"></i>
          </b-button>
        </template>
      </template>
    </b-table>
    <slot></slot>
  </div>
</template>

<script>
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      fields: {
        type: Array,
        default() {
          return [
            { key: 'areaName', label: 'Tên' },
            { key: 'areaAddress', label: 'Địa chỉ' },
            { key: 'areaUrl', label: 'Ảnh cửa hàng', class: 'text-center' },
          ]
        },
      },
    },
    computed: {
      wrapItems() {
        return this.items.filter(s => s.isChoose === true)
      },
    },
    methods: {
      showImage(data) {
        this.showModalComponentMx('Ảnh cửa hàng', {
          name: UploadMultiple,
          props: {
            lsData: data,
            canUpload: false,
          },
        })
      },
    },
  }
</script>
